module.exports = __webpack_public_path__ + "img/text.d7bb0446.png";